import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { EuiButton, EuiCallOut, EuiFlexGroup, EuiFlexItem, EuiLoadingContent, EuiPageBody, EuiPageHeader, EuiPageHeaderSection, EuiPanel, EuiSpacer, EuiTab, EuiTabs, EuiTitle } from '@elastic/eui'

import { useGetMasterCampaignCampaignsQuery, useGetMasterCampaignQuery } from 'api/rtkQueryApi/platform/masterCampaignsApi'
import { RootState } from 'app/rootReducer'
import { MasterCampaignSettings } from 'features/campaigns/masterCampaigns/MasterCampaignSettings'

import { GroupCampaignsList } from './GroupCampaignsList'

export interface MasterCampaignPagePageParams {
  masterCampaignId: string
}

enum MasterCampaignTabs {
  campaigns = 'campaigns',
  settings = 'settings'
}

export const MasterCampaignPage = () => {
  const { masterCampaignId } = useParams<MasterCampaignPagePageParams>()
  const currentAccount = useSelector((state: RootState) => state.app.currentAccount)
  const [selectedTabType, setSelectedTabType] = useState<MasterCampaignTabs>(MasterCampaignTabs.campaigns)

  const onTabClick = (type: MasterCampaignTabs) => {
    setSelectedTabType(type)
  }

  const { data: masterCampaign } = useGetMasterCampaignQuery({ masterCampaignId }, { skip: !masterCampaignId })
  const { data: campaigns } = useGetMasterCampaignCampaignsQuery({ masterCampaignId: masterCampaignId }, { skip: !masterCampaignId })

  if (!masterCampaign || !campaigns) {
    return <EuiLoadingContent />
  }

  return (
    <EuiPageBody>
      <Helmet>
        <title>{masterCampaign?.name}</title>
      </Helmet>
      <EuiPageHeader>
        <EuiPageHeaderSection>
          <EuiTitle>
            <h1>Master Campaign: {currentAccount?.name}</h1>
          </EuiTitle>
        </EuiPageHeaderSection>
      </EuiPageHeader>
      <EuiPanel grow={false}>
        <>
          <EuiFlexGroup>
            <EuiFlexItem>
              <EuiTitle size={'s'}>
                <h2>{masterCampaign?.name}</h2>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer />
          {!masterCampaign.paymentMethodSelectedDate && (
            <>
              <EuiCallOut title='No payment method selected' color='warning' iconType='alert'>
                <p>Campaigns will not be activated until a payment method is selected.</p>
                <EuiButton onClick={() => setSelectedTabType(MasterCampaignTabs.settings)} color='warning'>
                  Go to Settings
                </EuiButton>
              </EuiCallOut>
              <EuiSpacer />
            </>
          )}
          <EuiTabs>
            <EuiTab onClick={() => onTabClick(MasterCampaignTabs.campaigns)} isSelected={selectedTabType === MasterCampaignTabs.campaigns}>
              Campaigns
            </EuiTab>
            <EuiTab onClick={() => onTabClick(MasterCampaignTabs.settings)} isSelected={selectedTabType === MasterCampaignTabs.settings}>
              Settings
            </EuiTab>
          </EuiTabs>
          <EuiSpacer />
          {selectedTabType === MasterCampaignTabs.campaigns && <GroupCampaignsList masterCampaignId={masterCampaignId} />}
          {selectedTabType === MasterCampaignTabs.settings && <MasterCampaignSettings masterCampaignId={masterCampaignId} />}
        </>
      </EuiPanel>
    </EuiPageBody>
  )
}
